<div class="company-layout">
  @if (isAdmin) {
    <section class="company-summary overflow-hidden rounded border border-[var(--mat-sys-outline-variant)] bg-[var(--mat-sys-surface)] shadow-sm">
      <div class="relative h-28 w-full">
        <img src="assets/images/backgrounds/company-profile-banner.png" alt="" class="h-full w-full object-cover opacity-95" />

        <button type="button" (click)="close()"
          class="group absolute top-3 right-3 flex size-9 cursor-pointer items-center justify-center rounded-full border border-white/30 bg-white/20 backdrop-blur-sm transition-colors hover:bg-white/90"
          [attr.aria-label]="'close' | translate">
          <i-tabler name="x" class="icon-18 d-flex text-white! transition-colors group-hover:text-slate-700!" />
        </button>

        <div class="absolute bottom-0 left-6 translate-y-1/2 sm:left-12">
          <div class="rounded-full bg-white p-1">
            <div class="flex size-24 items-center justify-center rounded-full border-4 border-white bg-gradient-to-br from-green-500 to-blue-500">
              <span class="text-2xl font-bold uppercase text-white">{{ companyInitial }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="company-summary-info min-w-0 px-4 pt-2 sm:pl-48">
        <h3 class="truncate text-xl font-medium">{{ company?.name }}</h3>
        <p class="mt-0.5 truncate text-sm text-slate-600 dark:text-slate-300">{{ company?.email }}</p>
      </div>

      <nav class="company-tabs flex overflow-x-auto border-t border-[var(--mat-sys-outline-variant)] px-4 sm:px-8" aria-label="Company detail">
        <a [routerLink]="['/admin/companies', companyId]" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }" class="company-tab shrink-0">
          {{ 'information' | translate }}
        </a>
        <a [routerLink]="['/admin/companies', companyId, 'invoice-address']" routerLinkActive="active"
          class="company-tab shrink-0">
          {{ 'invoice address' | translate }}
        </a>
        <a [routerLink]="['/admin/companies', companyId, 'users']" routerLinkActive="active"
          class="company-tab flex shrink-0 items-center gap-2">
          {{ 'users' | translate }}
          <span class="user-count inline-flex min-w-5 items-center justify-center rounded-full px-1.5 text-xs font-medium">{{ userCount }}</span>
        </a>
      </nav>
    </section>
  }

  <div class="company-layout-content" [class.admin-content]="isAdmin">
    <router-outlet></router-outlet>
  </div>
</div>
